import React, { useEffect, useState } from 'react';

import { ItemGroupForm } from '../../../Components/Form';
import FormLayout from '../../../Components/Layout/FormLayout';
import { NewItemIcon } from '../../../Assets/Navigation/NavigationIcons';
import { useTranslation } from 'react-i18next';

const EditItemGroups = ({ handleToast, idFromHeaderWrapper, ...props }) => {
  const { t } = useTranslation();
  const [, setStep] = useState(false);

  useEffect(() => {
    document.title = t('Items.edit_item_group');
  }, []);
  const handleStep = () => setStep(true);

  return (
    <FormLayout
      title={t('Items.item_groups')}
      Icon={NewItemIcon}
      closeUrl="/item-groups"
      iconstyle="general_module_icon"
      subtitle={t('Items.edit')}
      layoutBoxClass="uiux-form-redesign"
    >
      <ItemGroupForm
        type="edit"
        id={idFromHeaderWrapper ? idFromHeaderWrapper : props.match.params.id}
        handleToast={handleToast}
        handleStep={handleStep}
      />
    </FormLayout>
  );
};

export default EditItemGroups;
